import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { faqs } from "@/lib/faq-data";
import Reveal from "@/components/Reveal";


const FAQSection = () => {
  return (
    <section className="section-padding section-gradient-soft">
      <div className="container-max max-w-3xl">
        <div className="text-center mb-14 md:mb-16">
          <Reveal
            as="span"
            y={10}
            className="inline-block text-primary text-sm font-bold uppercase tracking-widest mb-3"
          >
            Got Questions?
          </Reveal>
          <Reveal
            as="h2"
            y={20}
            className="font-heading text-4xl md:text-5xl lg:text-6xl text-foreground mb-4 tracking-tight font-bold"
          >
            Frequently Asked <span className="text-gradient-primary">Questions</span>
          </Reveal>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <Reveal
              as="div"
              y={15}
              delay={i * 0.05}
              duration={0.4}
              key={i}
            >
              <AccordionItem
                value={`faq-${i}`}
                className="bg-card rounded-xl border border-border px-6 data-[state=open]:shadow-md data-[state=open]:border-primary/20 transition-all"
              >
                <AccordionTrigger className="font-heading text-base md:text-lg tracking-tight text-foreground hover:no-underline py-5 text-left font-semibold">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm md:text-base leading-relaxed pb-5 text-left">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            </Reveal>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
